import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Row, Col, Input } from 'antd';

import { AgGrid } from 'common/components';

import * as actions from 'pages/branded-products-apl/controllers/actions';
import * as selectors from 'pages/branded-products-apl/controllers/selectors';

import { REDUX_MODULE, useInjectRedux } from 'hooks/useRedux';

import { GRID_ID } from 'common/components/grid-view/utils';

import { MASTER_APL_NAME } from 'pages/home/ribbon/components/sections/product-apl/constants';

import * as endpoints from 'services/product/endpoints';

const { Search } = Input;

const AplGrid = (props) => {
  const dispatch = useDispatch();

  useInjectRedux(REDUX_MODULE.PRODUCT_APL);

  const { onSelectRow } = props;

  const [searchText, setSearchText] = useState(null);

  const columns = useSelector(selectors.selectProductAPLColumns());

  const onSearch = (value) => {
    setSearchText(value);
  };

  useEffect(() => {
    dispatch(
      actions.getAPLGridColumns({
        linkTarget: '_blank',
      })
    );
  }, [dispatch]);

  const rowClassRules = {
    'active-row': ({ data }) => data?.aplName === MASTER_APL_NAME,
  };

  return (
    <Row style={{ flexDirection: 'column', height: '100%' }}>
      <Col flex={0} style={{ marginBottom: 8 }}>
        <Search
          placeholder='Search APL'
          allowClear
          onSearch={onSearch}
          style={{ width: '100%' }}
        />
      </Col>
      <Col flex={1}>
        <AgGrid
          gridId={GRID_ID.ADD_PRODUCT_TO_APL}
          sortAndFilterServerside
          notShowHeaderCheckbox
          columnDefs={columns}
          urlGrid={endpoints.PRODUCT_APL_GRID}
          urlGridDistinct={endpoints.PRODUCT_APL_GRID_DISTINCT}
          responseParams='data'
          paramsGrid={{
            search: { searchText: searchText, primaryFieldsOnly: true },
          }}
          rowClassRules={rowClassRules}
          gridConfigProps={{ rowSelection: 'single' }}
          onHandleSelectedRowCustom={onSelectRow}
        />
      </Col>
    </Row>
  );
};

export default AplGrid;
